import { render, staticRenderFns } from "./ChangePosition.vue?vue&type=template&id=9f4fe02c&scoped=true"
import script from "./ChangePosition.vue?vue&type=script&lang=js"
export * from "./ChangePosition.vue?vue&type=script&lang=js"
import style0 from "./ChangePosition.vue?vue&type=style&index=0&id=9f4fe02c&prod&lang=scss&scoped=true"
import style1 from "./ChangePosition.vue?vue&type=style&index=1&id=9f4fe02c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4fe02c",
  null
  
)

export default component.exports